// extracted by mini-css-extract-plugin
module.exports = {"menu_container":"styles_menu_container__29Xg6","avatar":"styles_avatar__3QcnB"};